import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";

import {
  faBellExclamation as fafBellExclamation,
  // faAccessibleIcon as falAccessibleIcon,
  faBars as falBars,
  faBath as falBath,
  faBell as falBell,
  faBookOpen as falBookOpen,
  faBookmark as falBookmark,
  faBooks as falBooks,
  faCalendar as falCalendar,
  faCalendarAlt as falCalendarAlt,
  faCarGarage as falCarGarage,
  faChartLine as falChartLine,
  faCheeseburger as falCheeseburger,
  faCircle as falCircle,
  faClipboard as falClipboard,
  faClock as falClock,
  faCocktail as falCocktail,
  faComment as falComment,
  faCompass as falCompass,
  faCreditCard as falCreditCard,
  faDollarSign as falDollarSign,
  faDonate as falDonate,
  faDumbbell as falDumbbell,
  faEnvelope as falEnvelope,
  faExclamationTriangle as falExclamationTriangle,
  faFile as falFile,
  faFileAlt as falFileAlt,
  faFileImage as falFileImage,
  faFilePdf as falFilePdf,
  faFutbol as falFutbol,
  faGlassCheers as falGlassCheers,
  faGraduationCap as falGraduationCap,
  faGripHorizontal as falGripHorizontal,
  faHeart as falHeart,
  faHome as falHome,
  faHomeAlt as falHomeAlt,
  faHotTub as falHotTub,
  faInfoCircle as falInfoCircle,
  faKey as falKey,
  faListUl as falListUl,
  faLockAlt as falLockAlt,
  faMapMarkedAlt as falMapMarkedAlt,
  faMapMarkerAlt as falMapMarkerAlt,
  faMapMarkerCheck as falMapMarkerCheck,
  faMapMarkerEdit as falMapMarkerEdit,
  faMedal as falMedal,
  faMoneyCheckAlt as falMoneyCheckAlt,
  faMotorcycle as falMotorcycle,
  faNewspaper as falNewspaper,
  faPaperclip as falPaperclip,
  faPencilAlt as falPencilAlt,
  faPhone as falPhone,
  faPlus as falPlus,
  faPlusCircle as falPlusCircle,
  faPlusSquare as falPlusSquare,
  faPollH as falPollH,
  faQrcode as falQrcode,
  faQuestion as falQuestion,
  faQuestionSquare as falQuestionSquare,
  faRunning as falRunning,
  faSearchLocation as falSearchLocation,
  faShoppingBag as falShoppingBag,
  faSignOutAlt as falSignOutAlt,
  faSlidersH as falSlidersH,
  faSpa as falSpa,
  faSparkles as falSparkles,
  faSpinnerThird as falSpinnerThird,
  faStore as falStore,
  faTennisBall as falTennisBall,
  faTheaterMasks as falTheaterMasks,
  faTicketAlt as falTicketAlt,
  faTimes as falTimes,
  faTrashAlt as falTrashAlt,
  faTrophy as falTrophy,
  faUmbrella as falUmbrella,
  faUser as falUser,
  faUserFriends as falUserFriends,
  faUserGraduate as falUserGraduate,
  faUserMd as falUserMd,
  faUserMinus as falUserMinus,
  faUsers as falUsers,
  faUtensils as falUtensils,
  faVolume as falVolume,
  faWallet as falWallet,
  faWater as falWater,
} from "@fortawesome/pro-light-svg-icons";

import {
  faArrowLeft as farArrowLeft,
  faArrowToBottom as farArrowToBottom,
  faChevronDown as farChevronDown,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faChevronUp as farChevronUp,
  faCircle as farCircle,
  faCopy as farCopy,
  faDotCircle as farDotCircle,
  faEraser as farEraser,
  faExclamationCircle as farExclamationCircle,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faHeart as farHeart,
  faInfoCircle as farInfoCircle,
  faKey as farKey,
  faLocation as farLocation,
  faMapMarkedAlt as farMapMarkedAlt,
  faMapMarkerAlt as farMapMarkerAlt,
  faMotorcycle as farMotorcycle,
  faPaperclip as farPaperclip,
  faRocketLaunch as farRocketLaunch,
  faShoppingCart as farShoppingCart,
  faSync as farSync,
  faTrashAlt as farTrashAlt,
  faUmbrella as farUmbrella,
  faUsdCircle as farUsdCircle,
  faUserFriends as farUserFriends,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faAngleRight as fasAngleRight,
  faArrowDown as fasArrowDown,
  faBadgePercent as fasBagePercent,
  faBallotCheck as fasBallotCheck,
  faBasketballBall as fasBasketballBall,
  faBell as fasBell,
  faBellOn as fasBellOn,
  faBookmark as fasBookmark,
  faBoxHeart as fasBoxHeart,
  faCalendarAlt as fasCalendarAlt,
  faCamera as fasCamera,
  faCameraAlt as fasCameraAlt,
  faCarGarage as fasCarGarage,
  faCaretDown as fasCaretDown,
  faCartArrowDown as fasCartArrowDown,
  faCheckCircle as fasCheckCircle,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faCircle as fasCircle,
  faClock as fasClock,
  faCoin as fasCoin,
  faComment as fasComment,
  faCommentAltSmile as fasCommentAltSmile,
  faCommentDots as fasCommentDots,
  faCommentPlus as fasCommentPlus,
  faCompass as fasCompass,
  faConciergeBell as fasConciergeBell,
  faCreditCardBlank as fasCreaditCardBlank,
  faCreditCard as fasCreditCard,
  faCreditCardFront as fasCreditCardFront,
  faDollarSign as fasDollarSign,
  faDumbbell as fasDumbbell,
  faExclamation as fasExclamation,
  faExclamationTriangle as fasExclamationTriangle,
  faGift as fasGift,
  faGripHorizontal as fasGripHorizontal,
  faHeadset as fasHeadset,
  faHeart as fasHeart,
  faHome as fasHome,
  faIdBadge as fasIdBadge,
  faIdCard as fasIdCard,
  faImage as fasImage,
  faImages as fasImages,
  faInfoCircle as fasInfoCircle,
  faKey as fasKey,
  faLaugh as fasLaugh,
  faListOl as fasListOl,
  faListUl as fasListUl,
  faMapMarkedAlt as fasMapMarkedAlt,
  faMinus as fasMinus,
  faMoneyBillWave as fasMoneyBillWave,
  faMoneyCheckAlt as fasMoneyCheckAlt,
  faMotorcycle as fasMotorcycle,
  faPaperPlane as fasPaperPlane,
  faPaperclip as fasPaperclip,
  faPlus as fasPlus,
  faPlusCircle as fasPlusCircle,
  faQrcode as fasQrcode,
  faQuestionCircle as fasQuestionCircle,
  faShoppingBag as fasShoppingBag,
  faSparkles as fasSparkles,
  faSpinner as fasSpinner,
  faStar as fasStar,
  faStore as fasStore,
  faTags as fasTags,
  faThermometerHalf as fasThermometerHalf,
  faTicketAlt as fasTicketAlt,
  faTimes as fasTimes,
  faTimesCircle as fasTimesCircle,
  faTruck as fasTruck,
  faUmbrella as fasUmbrella,
  faUser as fasUser,
  faUserFriends as fasUserFriends,
  faUserMd as fasUserMd,
  faUtensils as fasUtensils,
  faUtensilsAlt as fasUtensilsAlt,
  faWallet as fasWallet,
} from "@fortawesome/pro-solid-svg-icons";

import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";

library.add(
  //light
  // falAccessibleIcon,
  falPollH,
  falExclamationTriangle,
  falSpinnerThird,
  fafBellExclamation,
  falBars,
  falBath,
  falBell,
  falBookmark,
  falBookOpen,
  falBooks,
  falCalendar,
  falCalendarAlt,
  falCarGarage,
  falChartLine,
  falCheeseburger,
  falCircle,
  falClipboard,
  falClock,
  falCocktail,
  falComment,
  falCompass,
  falCreditCard,
  falDollarSign,
  falDonate,
  falDumbbell,
  falEnvelope,
  falFile,
  falFileAlt,
  falFileImage,
  falFilePdf,
  falFutbol,
  falGlassCheers,
  falGraduationCap,
  falGripHorizontal,
  falHeart,
  falHome,
  falHomeAlt,
  falHotTub,
  falInfoCircle,
  falKey,
  falListUl,
  falMapMarkedAlt,
  falMapMarkerAlt,
  falMapMarkerCheck,
  falMapMarkerEdit,
  falMedal,
  falMoneyCheckAlt,
  falMotorcycle,
  falNewspaper,
  falPencilAlt,
  falPhone,
  falPlus,
  falPlusCircle,
  falPlusSquare,
  falQrcode,
  falQuestion,
  falQuestionSquare,
  falRunning,
  falSearchLocation,
  falShoppingBag,
  falSignOutAlt,
  falSpa,
  falSparkles,
  falStore,
  falTennisBall,
  falTheaterMasks,
  falTicketAlt,
  falTicketAlt,
  falTimes,
  falTrashAlt,
  falTrophy,
  falUmbrella,
  falUser,
  falUserFriends,
  falUserGraduate,
  falUserMd,
  falUserMinus,
  falUsers,
  falUtensils,
  falVolume,
  falWallet,
  falWater,
  falPaperclip,
  falSlidersH,
  falLockAlt,

  //regular,
  farArrowLeft,
  farArrowToBottom,
  farChevronDown,
  farChevronUp,
  farChevronLeft,
  farChevronRight,
  farCopy,
  farEye,
  farEyeSlash,
  farHeart,
  farInfoCircle,
  farKey,
  farMapMarkedAlt,
  farMapMarkerAlt,
  farMotorcycle,
  farShoppingCart,
  farSync,
  farUmbrella,
  farUmbrella,
  farUsdCircle,
  farUserFriends,
  farTrashAlt,
  farPaperclip,
  farExclamationCircle,
  farLocation,
  farEraser,
  farDotCircle,
  farCircle,
  farRocketLaunch,

  //solid,
  fasArrowDown,
  fasBell,
  fasBellOn,
  fasBookmark,
  fasCalendarAlt,
  fasBallotCheck,
  fasCarGarage,
  fasCheckCircle,
  fasCircle,
  fasCompass,
  fasDumbbell,
  fasGripHorizontal,
  fasHeart,
  fasHome,
  fasInfoCircle,
  fasKey,
  fasListUl,
  fasMapMarkedAlt,
  fasMotorcycle,
  fasPlusCircle,
  fasQrcode,
  fasShoppingBag,
  fasSparkles,
  fasStore,
  fasUmbrella,
  fasUser,
  fasUserFriends,
  fasUserMd,
  fasUtensils,
  fasWallet,
  fasDollarSign,
  fasConciergeBell,
  fasTags,
  fasTicketAlt,
  fasQuestionCircle,
  fasCreditCardFront,
  fasAngleRight,
  fasStar,
  fasCartArrowDown,
  fasIdCard,
  fasComment,
  fasBasketballBall,
  fasTruck,
  fasMinus,
  fasPlus,
  fasCoin,
  fasTimesCircle,
  fasChevronRight,
  fasChevronLeft,
  fasCreditCard,
  fasIdBadge,
  fasBagePercent,
  fasUtensilsAlt,
  fasCreaditCardBlank,
  fasPaperclip,
  fasPaperPlane,
  fasCameraAlt,
  fasCamera,
  fasImages,
  fasImage,
  fasTimes,
  fasSpinner,
  fasMoneyBillWave,
  fasGift,
  fasMoneyCheckAlt,
  fasExclamation,
  fasCommentAltSmile,
  fasBoxHeart,
  fasThermometerHalf,
  fasLaugh,
  fasListOl,
  fasClock,
  fasExclamationTriangle,
  fasCaretDown,
  fasHeadset,
  fasCommentPlus,
  fasCommentDots,

  //brands
  faFacebook,
  faGoogle
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
